import HasLabel from "./HasLabel";
import { RefillStatusCode } from "./Prescription";
import { Program } from "./Program";
import { Team } from "./Team";

export interface CustomFaxTemplateBase {
    id: number;
    active: boolean;
    templateImageId: number;
    name: string;
    created?: Date;
    createdBy?: string;
    updated?: Date;
    updatedBy?: string;
}

export class CustomFaxTemplateBase extends HasLabel {

    constructor(obj?: CustomFaxTemplateBase) {
        super();
        if (obj) Object.assign(this, obj);
    }

    toString(): string {
        let label = "";
        if (this.id) {
            label =
                "<b>" +
                this.name +
                "</b> - " +
                " <small>(ID: " +
                this.id + ")</small>";
        }
        return label;
    }

}

export interface PrescriberContactTemplate extends CustomFaxTemplateBase {
    programs: Program[];
    teams: Team[];
}

export class PrescriberContactTemplate extends CustomFaxTemplateBase {

    constructor(obj?: PrescriberContactTemplate) {
        super();
        if (obj) Object.assign(this, obj);
    }

    toString(): string {
        let label = "";
        if (this.id) {
            label =
                "<b>" +
                this.name +
                "</b> - " +
                " <small>(ID: " +
                this.id + ")</small>";
        }
        return label;
    }

}

export interface PriorAuthFaxTemplate extends CustomFaxTemplateBase {
    programs: Program[];
    additionalPdfImageId?: number | null;
}

export class PriorAuthFaxTemplate extends CustomFaxTemplateBase {

    constructor(obj?: PriorAuthFaxTemplate) {
        super();
        if (obj) Object.assign(this, obj);
    }

    toString(): string {
        let label = "";
        if (this.id) {
            label =
                "<b>" +
                this.name +
                "</b> - " +
                " <small>(ID: " +
                this.id + ")</small>";
        }
        return label;
    }

}

export interface PrescriberContactTrigger {
    id: number;
    active: boolean;
    prescriptionStatus: RefillStatusCode;
    prescriptionSubstatus?: number | null;
    delay: number;
    prescriberContactTemplate: PrescriberContactTemplate | null;
    programs?: Program[];
}